export default __webpack_public_path__ + "static/media/landing-desktop-03.60f2d0b1.png";